/**
 * Function helps to expand the filter selction on click.
 * 
 * @param {string} elementName the css class of the element
 * 
 * @returns void
 */
export const handleFilterSectionToggle = (elementName: string): void => {
  const parent: HTMLElement | null = document.querySelector(elementName);
  if (!parent) return;
  parent.addEventListener("click", () => {
    let arrow: HTMLElement | null = parent!.querySelector(".arrow");
    arrow!.classList.toggle("active");
  });
};
